import ResumeItem from '@/common/components/ResumeItem'
import CreateForwardingDirectiveEntryFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepCompleted'
import { MaintenanceForwardingsDirectiveFromSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { DirectiveDiagnosticValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useFormContext, useWatch } from 'react-hook-form'

const DirectiveDiagnosticFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic>) => {
  const { control } = useFormContext<DirectiveDiagnosticValidationSchema>()

  const { diagnostic: watchDiagnostic } = useWatch({
    control,
  })

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Selecionar o diagnóstico e orçamento"
      body={
        <div>
          <ResumeItem
            label="Diagnóstico e orçamento selecionado"
            value={(watchDiagnostic?.label as string | JSX.Element) || '--'}
            className="text-sm"
          />
        </div>
      }
    />
  )
}

export default DirectiveDiagnosticFormStepCompleted
